import { inject, Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ToastSeverity } from '#enums';

@Injectable({
  providedIn: 'root',
})
export class ToasterService {
  private messageService = inject(MessageService);

  showError(detail: string, summary = ''): void {
    this.messageService.add({
      detail,
      summary,
      sticky: true,
      closable: true,
      severity: ToastSeverity.Error,
    });
  }

  showWarning(detail: string, summary = '', life = 5000): void {
    this.messageService.add({
      detail,
      summary,
      severity: ToastSeverity.Warn,
      life,
    });
  }

  clear(): void {
    this.messageService.clear();
  }

  showSuccess(detail: string, summary = '', life = 5000, clearExisting = true): void {
    if (clearExisting) this.messageService.clear();
    this.messageService.add({
      detail,
      summary,
      severity: ToastSeverity.Success,
      life,
    });
  }

  showInfo(detail: string, summary = '', life = 3000): void {
    this.messageService.add({
      detail,
      summary,
      life,
      severity: ToastSeverity.Info,
    });
  }
}
